import { ModelBase } from "./model.base";
import { Operator } from "./operator.type";

export class ShortCode extends ModelBase {
    description: string;
    isdeleted: boolean;
    operator: Operator;
    operator_id: number;
    operatorId: number;
    type: string;
    create_date: Date;
    value: string;
    active: true;
    mask: string;
}
